<template>
  <div class="accessible-slider">
    <label :for="sliderId" class="visually-hidden">{{ label }}</label>
    <input
      :id="sliderId"
      type="range"
      class="accessible-slider__input"
      :min="min"
      :max="max"
      :step="step"
      :value="Number(value) || min"
      :disabled="disabled"
      :aria-valuetext="valueText"
      @input="$emit('input', Number($event.target.value))"
    />
  </div>
</template>

<script>
/*
  Replacement for vuesax's <vs-slider>, which renders only <button>s and <span>s: no
  native input, no role, no value, and no way to change it from the keyboard. That is the
  audit's "Slider not screen reader accessible" (39.1).

  A native <input type="range"> gets role="slider", the current value, arrow-key and
  Home/End support, and touch support for free (SC 2.1.1, SC 4.1.2).
*/
let uid = 0;

export default {
  name: 'accessible-slider',
  props: {
    value: { type: [Number, String], default: 0 },
    label: { type: String, required: true },
    min: { type: Number, default: 0 },
    max: { type: Number, default: 10 },
    step: { type: Number, default: 1 },
    disabled: { type: Boolean, default: false },
    // Spoken value, for scales where the number alone is not meaningful.
    minText: { type: String, default: '' },
    maxText: { type: String, default: '' },
  },
  data() {
    uid += 1;
    return { sliderId: `accessible-slider-${uid}` };
  },
  computed: {
    valueText() {
      const v = Number(this.value) || this.min;
      if (v === this.min && this.minText) return `${v} - ${this.minText}`;
      if (v === this.max && this.maxText) return `${v} - ${this.maxText}`;
      return String(v);
    },
  },
};
</script>

<style scoped>
.accessible-slider__input {
  width: 100%;
  min-width: 0;
  accent-color: rgba(var(--vs-primary), 1);
  cursor: pointer;
}
.accessible-slider__input:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
</style>
